import React, { Fragment, useEffect, useState } from 'react';
import { Button, DatePicker, Input, message, Row } from 'antd';
import TableCommon from '../../components/common/table/TableCommon';
import { currencyVND, dateToString } from '../../utils';
import * as CommonService from '../../services/CommonService';
import { INVOICE_ENDPOINT } from '../../services/endpoint';
import { useHistory } from 'react-router-dom';

const DEFAULT_PAGE = {
	currentPage: 1,
	perpage: 20
};

export default ({callback}) => {

	const [ds, setDs] = useState([]);
	const [loading, setLoading] = useState(false);
	const [searchValues, setSearchValues] = useState({});
	const [page, setPage] = useState({
		...DEFAULT_PAGE,
		total: 0
	});

	const history = useHistory();

	useEffect(() => {
		setLoading(true);
		CommonService.get(INVOICE_ENDPOINT, {
			page: page.currentPage - 1,
			size: page.perpage,
			status: 'COMPLETED'
		}).then(res => {
			setDs(res.data?.contents);
			setPage({ ...page, total: res.data?.totalElements });
		}).catch(error => {
			message.error(error?.data?.message);
		}).finally(() => setLoading(false));
	}, []);

	const onSearch = async (pageParam = DEFAULT_PAGE) => {
		const param = { ...searchValues, status: 'COMPLETED', page: pageParam.currentPage - 1, size: pageParam.perpage };
		setLoading(true);
		const resp = await CommonService.get(INVOICE_ENDPOINT, param);
		setDs(resp.data?.contents);
		setPage({
			total: resp.data?.totalElements,
			...pageParam
		});
		setLoading(false);
	};

	const columns = [
		{
			title: 'STT',
			dataIndex: 'index',
			width: 60,
			align: 'center',
			render: (text, record, index) => (page.currentPage - 1) * page.perpage + index + 1
		},
		{
			title: 'Mã đơn hàng',
			dataIndex: 'invoiceCode',
			align: 'center',
			width: 80,
			render: (text, record) => {
				return <Button style={{ padding: '0', textWrap: 'wrap' }} type={'link'}
											 onClick={() => window.open('/orders/' + record.id)}>{text}</Button>;
			}
		},
		{
			title: 'Ngày tạo đơn',
			dataIndex: 'createDate',
			width: 150,
			align: 'center',
			render: (text) => (<span>{dateToString(text)}</span>)
		},
		{
			title: 'Tên khách hàng',
			dataIndex: 'customerName',
			className: 'header-center-align',
			width: 200
		},
		{
			title: 'Giá trị đơn hàng',
			dataIndex: 'finalAmount',
			width: 120,
			align: 'center',
			render: (el) => <>{currencyVND(el)}</>
		},
		{
			title: 'Thao tác',
			width: 120,
			align: 'center',
			render: (el) => <Button type={'link'} onClick={() => {
				callback()
				goToCreate(el.id)
			}}>Chọn trả</Button>
		}
	];

	const handleChange = (value, key) => {
		searchValues[key] = value;
		setSearchValues({ ...searchValues });
	};

	const goToCreate = (id) => {
		history.push('/customer-refund/create?id=' + id);
	};

	return (<Fragment>
			<Row>
				<div style={{ display: 'flex', gap: 10, marginBottom: 16, maxHeight: '500px' }}>
					<Input
						style={{ height: '32px' }}
						placeholder="Tìm kiếm theo mã đơn hàng"
						allowClear
						onChange={(value) => handleChange(value.target.value, 'param')}
					/>
					<DatePicker.RangePicker
						allowClear
						placeholder={['Từ ngày', 'Đến ngày']}
						style={{ width: '400px' }}
						onChange={(value) => {
							const arr = value.map(el => dateToString(el, 'YYYY-MM-DD'));
							handleChange(arr[0], 'from');
							handleChange(arr[1], 'to');
						}} />
					<Button type="primary"
									style={{ width: '150px' }}
									onClick={() => onSearch(DEFAULT_PAGE)}>
						Tìm kiếm
					</Button>
				</div>
			</Row>
			<TableCommon bordered={true}
									 loading={loading}
									 page={page}
									 setPage={setPage}
									 datasource={ds}
									 columns={columns}
									 onSearch={onSearch}
			/>
		</Fragment>

	);
};
